import AddressesNotifications from '../src/components/sections/AddressesNotifications';

export default AddressesNotifications;
